





































































































































import { Component, Inject, Mixins } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import {
  IObjectNotificationProvider,
  IObjectNotificationProviderMethods
} from "@/models/providers/objectNotifications";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { DataModules } from "@/store/modules/data";
import { NotificationChannelCodes } from "@/data/enums/notifications";

@Component({
  components: {
    Treeselect
  }
})
export default class AddEditObjectNotificationMappingModal extends Mixins(
  HasValidation
) {
  // Inject
  @Inject({ from: "objectNotificationProvider" })
  public $objectNotificationProvider!: () => IObjectNotificationProvider;

  @Inject({ from: "objectNotificationMethods" })
  public $objNotificationMethods!: IObjectNotificationProviderMethods;

  // Data
  public form = this.initForm();
  public templateSearch = "";
  public isLoadingTempaltes = false;
  public hookLogEventsMap = {};

  // Life-cycle methods
  public async created() {
    const { HookLogEventsMap } = await import(
      "@/components/app/global/timelineComponent/events"
    );

    this.hookLogEventsMap = HookLogEventsMap;
  }

  // Computed

  public get isProcessing() {
    return this.$objNotificationsData.isProcessing;
  }

  public get $objNotificationsData() {
    return this.$objectNotificationProvider();
  }

  public get formIsDisabled() {
    return this.$_.isEqual(this.form, this.initForm()) || this.hasErrors;
  }

  public get hookOptions() {
    return this.$objNotificationsData.templateCategories.map(category => {
      return {
        id: category.id,
        label: category.name,
        children: category?.hooks?.map(hook => {
          return {
            id: hook.id,
            label: this.hookLogEventsMap[hook?.code]?.name || hook.name
          };
        })
      };
    });
  }

  public get selectedTemplate() {
    return this.$objNotificationsData.templates?.find(
      i => i.id === this.form.template_id
    );
  }

  public get selectedTemplateCategory() {
    return this.$objNotificationsData.templateCategories?.find(
      category => !!category.hooks?.find(hook => hook.id === this.form.hook_id)
    );
  }

  public get filteredTemplates() {
    return this.$objNotificationsData.templates;
  }

  // Methods

  public onTemplateSelected(template) {
    if (!template) return;
    this.form.template_id = template?.id;
  }

  public async addTemplateModal() {
    const modal = await this.$store.dispatch(
      `data/${DataModules.NOTIFICATIONS_TEMPLATES}/openAddTemplateModal`,
      {
        props: {
          showSubmitButton: false,
          showHookSelector: false,
          showChannelSelector: true,
          showActiveToggle: false,
          onlyEmitAfterSave: true,
          channelCode: NotificationChannelCodes.EMAIL,
          categoryCode: this.selectedTemplateCategory?.code
        },
        events: {
          "template-saved": async template => {
            try {
              modal.close();
              this.isLoadingTempaltes = true;
              await this.$objNotificationMethods.setTemplates();
              this.form.template_id = template.id;
            } finally {
              this.isLoadingTempaltes = false;
            }
          }
        }
      }
    );
  }

  public initForm() {
    return {
      hook_id: null,
      template_id: null
    };
  }

  public validateBeforeSubmit() {
    this.$objNotificationMethods.setProcessing(true);
    this.validate()
      .then(result => {
        if (result) {
          return this.$objNotificationMethods.create(this.form);
        }
        throw this.$t("_sentence.form_is_not_valid");
      })
      .then(() => {
        this.$store.dispatch("toast/show", {
          message: this.$t("_sentence.successfully_saved")
        });
        this.$emit("success");
        this.$emit("close");
      })
      .catch(error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      })
      .finally(() => {
        this.$objNotificationMethods.setProcessing(false);
      });
  }
}
